"use client";

import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isFocusTrap } from "./IGR4SXG2.js";
import { hideElementFromAccessibilityTree } from "./ESSM74HH.js";
import { supportsInert } from "./677M2CI3.js";
import { isBackdrop } from "./63XF7ACK.js";
import { walkTreeOutside } from "./AOUGVQZ3.js";
import { assignStyle, orchestrate, setAttribute, setProperty } from "./K2ZF5NU7.js";

// src/dialog/utils/disable-tree.ts
import { contains } from "@ariakit/core/utils/dom";
import { getAllTabbableIn } from "@ariakit/core/utils/focus";
import { chain, noop } from "@ariakit/core/utils/misc";
function disableTree(element, ignoredElements) {
  if (!("style" in element)) return noop;
  if (supportsInert()) {
    return setProperty(element, "inert", true);
  }
  var tabbableElements = getAllTabbableIn(element, true);
  var enableElements = tabbableElements.map(function (element2) {
    if (ignoredElements == null ? void 0 : ignoredElements.some(function (el) {
      return el && contains(el, element2);
    })) return noop;
    var restoreFocusMethod = orchestrate(element2, "focus", function () {
      element2.focus = noop;
      return function () {
        delete element2.focus;
      };
    });
    return chain(setAttribute(element2, "tabindex", "-1"), restoreFocusMethod);
  });
  return chain.apply(void 0, _toConsumableArray(enableElements).concat([hideElementFromAccessibilityTree(element), assignStyle(element, {
    pointerEvents: "none",
    userSelect: "none",
    cursor: "default"
  })]));
}
function disableTreeOutside(id, elements) {
  var cleanups = [];
  var ids = elements.map(function (el) {
    return el == null ? void 0 : el.id;
  });
  walkTreeOutside(id, elements, function (element) {
    if (isBackdrop.apply(void 0, [element].concat(_toConsumableArray(ids)))) return;
    if (isFocusTrap.apply(void 0, [element].concat(_toConsumableArray(ids)))) return;
    cleanups.unshift(disableTree(element, elements));
  }, function (element) {
    if (!element.hasAttribute("role")) return;
    if (elements.some(function (el) {
      return el && contains(el, element);
    })) return;
    cleanups.unshift(setAttribute(element, "role", "none"));
  });
  var restoreTreeOutside = function restoreTreeOutside() {
    for (var _i = 0, _cleanups = cleanups; _i < _cleanups.length; _i++) {
      var cleanup = _cleanups[_i];
      cleanup();
    }
  };
  return restoreTreeOutside;
}
export { disableTree, disableTreeOutside };